module.exports = __webpack_public_path__ + "static/media/noDraft.b4f06c2a.svg";